import { render, staticRenderFns } from "./CreateResources.vue?vue&type=template&id=066782eb&scoped=true&"
import script from "./CreateResources.vue?vue&type=script&lang=js&"
export * from "./CreateResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066782eb",
  null
  
)

export default component.exports